import axios from "axios";
import { agent } from "../utils/agent";
const API_URL = process.env.REACT_APP_API_URL;

const getAllTypeLeaderboard = async () => {
  const response = await agent.get(API_URL + "getAllTypeLeaderboard");
  return response.data;
};
const getScheduleData = async () => {
  const response = await agent.get(API_URL + "getScheduleData");
  return response.data;
};
const getMyScheduleData = async () => {
  const response = await agent.get(API_URL + "getMyScheduleData");
  return response.data;
};

const showHeadToHeadRound = async (roundId) => {
  const response = await agent.get(API_URL + "showHeadToHeadRound/" + roundId);
  return response.data;
};
const showGroupHeadToHeadRound = async (type, roundId) => {
  const response = await agent.get(
    API_URL + "showGroupHeadToHeadRound/" + type + "/" + roundId
  );
  return response.data;
};

const getPlayOffdata = async (playOffNumber) => {
  const response = await agent.get(API_URL + "getPlayOffdata/" + playOffNumber);
  return response.data;
};
const getPlayOffListing = async () => {
  const response = await agent.get(API_URL + "getPlayOffListing");
  return response.data;
};
const viewPlayOff = async () => {
  const response = await agent.get(API_URL + "viewPlayOff");
  return response.data;
};
const headToHeadGroupLeaderboard = async () => {
  const response = await agent.get(API_URL + "headToHeadGroupLeaderboard");
  return response.data;
};
const viewMyH2h = async (roundId) => {
  const response = await agent.get(API_URL + "viewMyH2h/" + roundId);
  return response.data;
};

const HeadToHeadService = {
  getAllTypeLeaderboard,
  getScheduleData,
  showHeadToHeadRound,
  showGroupHeadToHeadRound,
  getPlayOffListing,
  getPlayOffdata,
  viewPlayOff,
  headToHeadGroupLeaderboard,
  viewMyH2h,
  getMyScheduleData,
};

export default HeadToHeadService;
